module.exports = __webpack_public_path__ + "img/Weapon_274.3de8ef05.png";